export default "__VITE_ASSET__d7c0c6d1__"